import script from "./FIUTemplaces.vue?vue&type=script&setup=true&lang=js"
export * from "./FIUTemplaces.vue?vue&type=script&setup=true&lang=js"

import "./FIUTemplaces.vue?vue&type=style&index=0&id=f3f05118&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3f05118"]])

export default __exports__